import axios from "axios";

export const ADMIN_TOKEN_KEY = "hc_admin_token";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const adminApi = axios.create({ baseURL: `${BACKEND_URL}/api` });

adminApi.interceptors.request.use((cfg) => {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY);
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith("/back-office") && !path.endsWith("/login")) {
        localStorage.removeItem(ADMIN_TOKEN_KEY);
        window.location.href = "/back-office/login";
      }
    }
    return Promise.reject(err);
  }
);

export default adminApi;
